// extracted by mini-css-extract-plugin
export default {"EditableProjectTitle":"EditableProjectTitle_EditableProjectTitle__94Bfq"};